var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{on:{"click":_vm.clearSelectedFacets}},[_vm._v("\n\tClear All\n\t"),_c('span',{class:_vm.isMobile && 'hide-aria'},[_vm._v("Filters")])])
}
var staticRenderFns = []

export { render, staticRenderFns }